import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Select, {components} from 'react-select';
import ReactSelectAdapter from './ReactSelectAdapter';
import ResetButton from './ResetButton';
import translate from '../../services/translation';
import SelectIcon from '../Favourites/SelectIcon';

export default class IndependentMultiSelector extends Component {

    static propTypes = {
        name: PropTypes.string,
        defaultOptionLabel: PropTypes.string,
        options: PropTypes.array,
        selectedOptions: PropTypes.array,
        onChange: PropTypes.func,
        resetFunction: PropTypes.func,
        disabled: PropTypes.bool,
        hasSpecialIcon: PropTypes.bool
    };

    handleUpdateEvent = (updateEvent) => {
        const values = updateEvent !== null ? updateEvent.map(item => item.value) : [];

        const event = {
            target: {
                name: this.props.name,
                value: values
            }
        };

        this.props.onChange(event);
    };

    render() {
        const {defaultOptionLabel, options, selectedOptions, disabled, resetFunction, name} = this.props;

        const castOptions = options ? options.map(option => {
            return {value: option.uid || option.value, label: option.title || option.label};
        }) : [];

        const selectedOptionsArray = selectedOptions ? selectedOptions.map(selectedOption => castOptions.find(option => option.value === selectedOption)) : selectedOptions;

        const DropdownIndicator = props => {
            return (
                <components.DropdownIndicator {...props}>
                    {this.props.hasSpecialIcon ? (<SelectIcon/>) : null}
                </components.DropdownIndicator>
            );
        };

        return (
            <React.Fragment>
                <div className={'selectCustom'}>
                    <Select
                        value={selectedOptionsArray}
                        onChange={this.handleUpdateEvent}
                        options={castOptions}
                        isDisabled={disabled}
                        isMulti={true}
                        isClearable={false}
                        isSearchable={false}
                        placeholder={defaultOptionLabel}
                        styles={ReactSelectAdapter.customStyles}
                        classNamePrefix={'select-basic'}
                        noOptionsMessage={() => translate('planner_list.no_options')}
                        components={{DropdownIndicator}}
                    />
                    {resetFunction && !disabled &&
                        <ResetButton reset={resetFunction} value={selectedOptionsArray.length} filterKey={name}/>
                    }
                </div>
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Planner/IndependentMultiSelector.js